import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createTicketDetailsSlice = (set, get) => ({
    ticketDetails: {
        loading: false,
        data: [],
    },
    postAdminMessage: async (params) => {
        const { dataToSend } = params;
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ ticketDetails: { ...state.ticketDetails, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: 'post',
                baseURL: config.apiUrls(),
                url: '/v1/business/ticket-detail-with-attachments',
                data: dataToSend,
                headers: { token }
            });
            set(state => ({ ticketDetails: { loading: false, data: resp.data } }));
            // Additional actions like notifying success, toggling modals, etc. would go here
        } catch (error) {
            set(state => ({ ticketDetails: { ...state.ticketDetails, loading: false } }));
        }
    },
    getTicketDetails: async (Id) => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ ticketDetails: { ...state.ticketDetails, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: 'get',
                baseURL: config.apiUrls(),
                url: `/v1/business/ticket/${Id}`,
                headers: { token }
            });
            set(state => ({ ticketDetails: { loading: false, data: resp.data } }));
        } catch (error) {
            set(state => ({ ticketDetails: { ...state.ticketDetails, loading: false } }));
        }
    }
});
